import { useNavigate } from 'react-router-dom'
import { RiHome4Line, RiArrowLeftLine } from 'react-icons/ri'
import { ROUTES } from '@/constants/routes'
import { Button } from '@/components/ui'
import styles from './NotFound.module.css'

export function NotFound() {
    const navigate = useNavigate()

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <h1>404</h1>
                <h2>Página no encontrada</h2>
                <p>
                    La página que buscas no existe o fue movida. Verifica la URL o vuelve al inicio.
                </p>
                <div className={styles.actions}>
                    <Button
                        variant="primary"
                        onClick={() => navigate(ROUTES.home)}
                    >
                        <RiHome4Line /> Ir al inicio
                    </Button>
                    <Button
                        variant="secondary"
                        onClick={() => window.history.back()}
                    >
                        <RiArrowLeftLine /> Volver atrás
                    </Button>
                </div>
            </div>
        </div>
    )
}
